import * as i0 from '@angular/core';
import { InjectionToken, inject, Directive } from '@angular/core';
import { NavigationStart, NavigationEnd, NavigationCancel, NavigationError, Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter, map, tap } from 'rxjs';
import * as i1 from 'ngx-progressbar';
import { NgProgressRef } from 'ngx-progressbar';
const defaultRouterOptions = {
  minDuration: 0,
  startEvents: [NavigationStart],
  completeEvents: [NavigationEnd, NavigationCancel, NavigationError]
};
const NG_PROGRESS_ROUTER_OPTIONS = new InjectionToken('NG_PROGRESS_ROUTER_OPTIONS', {
  providedIn: 'root',
  factory: () => defaultRouterOptions
});
function provideNgProgressRouter(options) {
  return {
    provide: NG_PROGRESS_ROUTER_OPTIONS,
    useValue: {
      ...defaultRouterOptions,
      ...options
    }
  };
}

/**
 * Check if a router event type exists in an array of router event types
 */
function eventExists(routerEvent, events) {
  return events.some(e => routerEvent instanceof e);
}
let NgProgressRouterBase = /*#__PURE__*/(() => {
  class NgProgressRouterBase {
    constructor() {
      this.router = inject(Router);
      this.config = inject(NG_PROGRESS_ROUTER_OPTIONS);
      this.progressRef = inject(NgProgressRef, {
        host: true,
        self: true
      });
      let completeTimeout;
      // Previously in v13, we had the router events toggle converted to a signal,
      // the issue with toSignal is when the new route is loaded too fast, it won't start the progressbar, causing the tests to break.
      // Therefore, we switched back to stream subscription to make sure it always starts and completes with the route events.
      this.router.events.pipe(filter(event => eventExists(event, [...this.config.startEvents, ...this.config.completeEvents])), map(event => eventExists(event, this.config.startEvents)), tap(toggle => {
        clearTimeout(completeTimeout);
        if (toggle) {
          this.progressRef.start();
        } else {
          completeTimeout = setTimeout(() => {
            this.progressRef.complete();
          }, this.config.minDuration);
        }
      }), takeUntilDestroyed()).subscribe();
    }
    static {
      this.ɵfac = function NgProgressRouterBase_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgProgressRouterBase)();
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NgProgressRouterBase
      });
    }
  }
  return NgProgressRouterBase;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgProgressRouter = /*#__PURE__*/(() => {
  class NgProgressRouter extends NgProgressRouterBase {
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵNgProgressRouter_BaseFactory;
        return function NgProgressRouter_Factory(__ngFactoryType__) {
          return (ɵNgProgressRouter_BaseFactory || (ɵNgProgressRouter_BaseFactory = i0.ɵɵgetInheritedFactory(NgProgressRouter)))(__ngFactoryType__ || NgProgressRouter);
        };
      })();
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NgProgressRouter,
        selectors: [["ng-progress", "ngProgressRouter", ""]],
        features: [i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return NgProgressRouter;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let NgProgressRouterRef = /*#__PURE__*/(() => {
  class NgProgressRouterRef extends NgProgressRouterBase {
    static {
      this.ɵfac = /* @__PURE__ */(() => {
        let ɵNgProgressRouterRef_BaseFactory;
        return function NgProgressRouterRef_Factory(__ngFactoryType__) {
          return (ɵNgProgressRouterRef_BaseFactory || (ɵNgProgressRouterRef_BaseFactory = i0.ɵɵgetInheritedFactory(NgProgressRouterRef)))(__ngFactoryType__ || NgProgressRouterRef);
        };
      })();
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: NgProgressRouterRef,
        selectors: [["", "ngProgressRouter", "", 5, "ng-progress"]],
        features: [i0.ɵɵHostDirectivesFeature([i1.NgProgressRef]), i0.ɵɵInheritDefinitionFeature]
      });
    }
  }
  return NgProgressRouterRef;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NG_PROGRESS_ROUTER_OPTIONS, NgProgressRouter, NgProgressRouterRef, provideNgProgressRouter };
